import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

const Shape = styled("svg")(({ theme }) => ({
  position: "absolute",
  top: 43,
  width: 13,
  zIndex: 1,
  [theme.breakpoints.up("mobile")]: {
    top: 65,
    width: 20,
  },
}));

const PlusShape = ({ color = "#FFFFFF" }) => {
  return (
    <Shape viewBox="0 0 27 27" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g stroke={color} strokeWidth="3">
          <path d="M11.6501789,-7.22977234e-13 L11.5825685,23.3793033 M23.2331128,11.5930823 L-1.24344979e-14,11.7858553" />
        </g>
      </g>
    </Shape>
  );
};

PlusShape.propTypes = {
  color: PropTypes.string,
};

export default PlusShape;
